import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/pdf.svg';

export const IconPdf: IconComponent = props => <Icon {...props} src={src} />;
